import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/searchOpdrachten'
import type { OpdrachtenSearch } from '../types/OpdrachtenSearch'

export { useOpdrachtenSearchStore }

const useOpdrachtenSearchStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<OpdrachtenSearch['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
